import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/dashboard/dashboardActions'
import * as api from '../../api/dashboard'

import moment from 'moment'

function* getLeadsPerMonth() {
  try {
    const payload = yield call(api.getLeadsPerMonth)
    yield put({ type: constants.GET_LEADS_PER_MONTH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEADS_PER_MONTH.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetLeadsPerMonth() {
  yield takeLatest(constants.GET_LEADS_PER_MONTH.ACTION, getLeadsPerMonth)
}

function* getLeadsStatusCountPerMonth() {
  try {
    const payload = yield call(api.getLeadsStatusCountPerMonth)
    yield put({ type: constants.GET_LEADS_STATUS_COUNT_PER_MONTH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEADS_STATUS_COUNT_PER_MONTH.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetLeadsStatusCountPerMonth() {
  yield takeLatest(constants.GET_LEADS_STATUS_COUNT_PER_MONTH.ACTION, getLeadsStatusCountPerMonth)
}

function* getDashboardFollowUps(action) {
  try {
    const params = {
      userId: action.userId,
      show30d: action.show30d
    }
    const payload = yield call(api.getDashboardFollowUps, params)
    yield put({ type: constants.GET_DASHBOARD_FOLLOW_UPS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_DASHBOARD_FOLLOW_UPS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetDashboardFollowUps() {
  yield takeLatest(constants.GET_DASHBOARD_FOLLOW_UPS.ACTION, getDashboardFollowUps)
}

function* sagaUpdateDashboardFollowUp(action) {
  try {
    const payload = {
      follow_up_data: {
        type: action.content.type,
        due_date: moment(action.content.due_date).format('YYYY-MM-DD hh:mm:ss'),
        description: action.content.description,
        status: action.content.status,
        updated_by_id: action.userId,
        assigned_to_id:
          action.content.assigned_to_type === 'user' ? action.content.assigned_to_id : null,
        assigned_to_role_id:
          action.content.assigned_to_type === 'role' ? action.content.assigned_to_role_id : null
      },
      id: action.followUpId
    }
    yield call(api.updateLDashboardFollowUp, payload)
    yield put({ type: constants.DASHBOARD_FOLLOW_UP_UPDATE.SUCCESS, payload })
    yield call(getDashboardFollowUps, {})
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DASHBOARD_FOLLOW_UP_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateDashboardFollowUp() {
  yield takeLatest(constants.DASHBOARD_FOLLOW_UP_UPDATE.ACTION, sagaUpdateDashboardFollowUp)
}

export function* rootSaga() {
  yield all([
    fork(watchGetLeadsPerMonth),
    fork(watchGetLeadsStatusCountPerMonth),
    fork(watchGetDashboardFollowUps),
    fork(watchUpdateDashboardFollowUp)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/dashboard/dashboardSaga.js